import React, { useEffect, useState } from "react";
import FilterPanelForm from "./FilterPanelForm";
import { useFilterStore } from "../store.js";
import { FilterPanelFormNavigation } from "./FilterPanelFormNavigation";

const FilterPanelFormWrapper = ({
	clubs,
	filterGetter,
	currentGraph
}) => {

	const isFiltersOpen = useFilterStore((state) => state.isFiltersOpen);

	return (
		<nav className={`filterPanel-wrapper ${isFiltersOpen ? "is-active" : ""}`}>
			<div className="filterPanel-inner-wrapper">
				<header className="filterPanel-wrapper-header">
					<p>Select up to 3 clubs</p>
				</header>
				<FilterPanelForm
					clubs={clubs}
					filterGetter={filterGetter}
					currentGraph={currentGraph}
				/>
			</div>

			<div className="filterPanel-footer">
				<FilterPanelFormNavigation/>
			</div>
		</nav>
	);
};

export default FilterPanelFormWrapper;
